<template>
    <div class="col-md-12">
        <form class="form-horizontal">
            <fieldset>
                <legend>Create Carehome</legend>

                <forminput v-bind:controller="controller.name"></forminput>
                <forminput v-bind:controller="controller.name"></forminput>
                <forminput v-bind:controller="controller.dob"></forminput>
                <forminput v-bind:controller="controller.dob"></forminput>
                <div class="form-group col-md-6">
                    <label for="inputEmail" class="col-lg-2 control-label">Email</label>
                    <div class="col-lg-10">
                        <input type="text" class="form-control" id="inputEmail" placeholder="Email">
                    </div>
                </div>
                <div class="form-group  col-md-6">
                    <label for="inputPassword" class="col-lg-2 control-label">Password</label>
                    <div class="col-lg-10">
                        <input type="password" class="form-control" id="inputPassword" placeholder="Password">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox"> Checkbox
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group  col-md-6">
                    <label for="textArea" class="col-lg-2 control-label">Textarea</label>
                    <div class="col-lg-10">
                        <textarea class="form-control" rows="3" id="textArea"></textarea>
                        <span class="help-block">A longer block of help text that breaks onto a new line and may extend beyond one line.</span>
                    </div>
                </div>
                <div class="form-group  col-md-6">
                    <label class="col-lg-2 control-label">Radios</label>
                    <div class="col-lg-10">
                        <div class="radio">
                            <label>
                                <input type="radio" name="optionsRadios" id="optionsRadios1" value="option1" checked="">
                                Option one is this
                            </label>
                        </div>
                        <div class="radio">
                            <label>
                                <input type="radio" name="optionsRadios" id="optionsRadios2" value="option2">
                                Option two can be something else
                            </label>
                        </div>
                    </div>
                </div>
                <div class="form-group  col-md-6">
                    <label for="select" class="col-lg-2 control-label">Selects</label>
                    <div class="col-lg-10">
                        <select class="form-control" id="select">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                        </select>
                        <br>
                        <select multiple="" class="form-control">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                        </select>
                    </div>
                </div>
                <div class="form-group  col-md-6"
                       v-bind:class="{ 'has-error' : controller.formValidator.hasError  }">
                     
                    <div class="col-lg-10 col-lg-offset-2">
                        <button type="reset" class="btn btn-default">Cancel</button>
                        <button type="submit" class="btn btn-primary"
                                :disabled="controller.formValidator.hasError">Submit</button>
                        <span class="help-block" v-if="controller.formValidator.hasError">
                            <i class="fa fa-exclamation-circle"></i>
                            <small>{{controller.formValidator.message}}</small>
                        </span>
                    </div>
                </div>
            </fieldset>
        </form>
        </div>
</template>

<script>

    import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    import carehomewardlist from "./../../carehome-wards/list/carehome-ward-list.scp.html"
    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'

    import { CarehomeCreateController } from './carehome-create-controller.ts'
    

    export default {
        data: function () {
            var controller = new CarehomeCreateController()
            return {
                controller: controller
            }
        },
        components: {
            forminput
        }
    }

</script>


// WEBPACK FOOTER //
// carehome-create.scp.html?169bd831